import React, { useEffect } from "react";
import Heading from "../../tailwindUI/Heading";
import Navbar from "../../tailwindUI/Navbar";
import Tab from "../../tailwindUI/Tab";
import classes from "../../module.css/ReallocationRequest.module.css";
import StackedList from "../../tailwindUI/StackedList";
import { useState } from "react";
import Modal from "../../tailwindUI/Modal";
import { Navigate, useLocation } from "react-router-dom";
import Pagination from "../../tailwindUI/Pagination";
import DataNotFound from "../../Components/DataNotFound";
import ErrorMessage from "../../tailwindUI/ErrorMessage";
import Input from "../../tailwindUI/Input";
import SuccessMessage from "../../tailwindUI/SuccessMessage";
import FollowUpRemarks from "../../Components/FollowUpRemarks";
const ReallocationRequest = () => {
  const [tabType, setTabType] = useState("Pending Request");
  const [cancel, setCancel] = useState(false);
  const [accept, setAccept] = useState(false);
  const [listData, setListData] = useState([]);
  const [historyListData, setHistoryListData] = useState([]);

  const [carDatail, setCarDetail] = useState({});
  const [followUpModal, setFollowUpModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [edd, setEdd] = useState("");
  const [reallocationValues, setReallocationValues] = useState("");
  const [tabCounts, setTabCounts] = useState("");
  const [pendingRequestCounts, setPendingRequestCounts] = useState("");
  const [reallocationHistoryCount, setReallocationHistoryCount] = useState("");
  const UserToken = localStorage.getItem("UserToken");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = parseInt(queryParams.get("page")) ? queryParams.get("page") : 1;
  const maxPages = Math.ceil(
    tabType === "Pending Request"
      ? pendingRequestCounts / 20
      : reallocationHistoryCount / 20
  );

  useEffect(() => {
    if (tabType === "Pending Request") {
      AMReAllocationRequestListAPI();
    }
    if (tabType === "Re-Allocation History") {
      AMReAllocationRequestHistoryListAPi();
    }
  }, [page, tabType]);

  useEffect(() => {
    AMReAllocationTabCountsAPi();
  }, []);

  const LogOut = () => {
    localStorage.removeItem("UserName");
    localStorage.removeItem("FirstName");
    localStorage.removeItem("LastName");
    localStorage.removeItem("UserToken");
    localStorage.removeItem("UserRole");
    localStorage.removeItem("Location");
    localStorage.removeItem("Email");
    localStorage.removeItem("UserLoggedin");
    Navigate("/login", { replace: true });
  };
  const AMReAllocationRequestListAPI = () => {
    setLoading(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: UserToken,
      page: page,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/am/AMReAllocationRequestList`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.data ===
            "Invalid User Token, The token may have expired, You may need to re-login" &&
          result.message ===
            "Invalid User Token, The token may have expired, You may need to re-login"
        ) {
          LogOut();
        } else if (result.status_code === 200 && result.status === "Success") {
          setListData(result.data);
          setPendingRequestCounts(result.datacount);
        } else if (result.status_code === 400) {
          setErrorMessage("Something went wrong please contact support !");
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      })
      .finally(() => setLoading(false));
  };

  const AMReAllocationRequestHistoryListAPi = () => {
    // console.log(values, "reallocationValues");
    setLoading(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: UserToken,
      page: page,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/am/AMReAllocationRequestHistoryList`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.data ===
            "Invalid User Token, The token may have expired, You may need to re-login" &&
          result.message ===
            "Invalid User Token, The token may have expired, You may need to re-login"
        ) {
          LogOut();
        } else if (result.status_code === 200 && result.status === "Success") {
          setHistoryListData(result.data);
          setReallocationHistoryCount(result.datacount);
        } else if (result.status_code === 400) {
          setErrorMessage("Something went wrong please contact support !");
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      })
      .finally(() => setLoading(false));
  };

  const AMReAllocationAcceptAPi = (values) => {
    // console.log(values, "reallocationValues");

    setLoading(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: UserToken,
      ReallocationID: values,
      AMEDD: edd,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/am/AMReAllocationAccept`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.data ===
            "Invalid User Token, The token may have expired, You may need to re-login" &&
          result.message ===
            "Invalid User Token, The token may have expired, You may need to re-login"
        ) {
          LogOut();
        } else if (result.status_code === 200 && result.status === "Success") {
          setAccept(false);
          setEdd("");
          setMessage(result.message);
          AMReAllocationRequestListAPI();
          AMReAllocationTabCountsAPi();
        } else if (result.status_code === 400) {
          setErrorMessage("Something went wrong please contact support !");
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      })
      .finally(() => setLoading(false));
  };

  const AMReAllocationDeniedAPi = (values) => {
    setLoading(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: UserToken,
      ReallocationID: values,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/am/AMReAllocationDenied`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.data ===
            "Invalid User Token, The token may have expired, You may need to re-login" &&
          result.message ===
            "Invalid User Token, The token may have expired, You may need to re-login"
        ) {
          LogOut();
        } else if (result.status_code === 200 && result.status === "Success") {
          setCancel(false);
          setMessage(result.message);
          AMReAllocationRequestListAPI();
          AMReAllocationTabCountsAPi();
        } else if (result.status_code === 400) {
          setErrorMessage("Something went wrong please contact support !");
        }
      })
      .catch((error) => console.log("error", error))
      .finally(() => setLoading(false));
  };

  const AMReAllocationTabCountsAPi = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: UserToken,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/am/AMReAllocationTabCounts`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status_code === 200 && result.status === "Success") {
          setTabCounts(result);
        }
      })
      .catch((error) => console.log("error", error));
  };

  const successMessage = () => {
    setTimeout(() => {
      setMessage("");
    }, 3000);
    return message;
  };
  const tabs = [
    {
      name: "Pending Request",
      count: tabCounts.ReAllocationRequest,
      current: true,
    },

    {
      name: "Re-Allocation History",
      count: tabCounts.ReAllocationRequestHistory,
      current: false,
    },
  ];

  const BreadCrumb = {
    pagename: "Re-Allocation Request",
    pagePath: "/stm-re-allocation-request",
    pagename1: "",
    pagePath1: "",
  };
  const values = (values) => {
    setReallocationValues(values);
  };

  const followUpHandler = (carDetail) => {
    setFollowUpModal(true);
    setCarDetail(carDetail);
  };
  return (
    <>
      {errorMessage && <ErrorMessage message={errorMessage} />}
      {message && (
        <SuccessMessage
          onClose={() => setMessage("")}
          message={successMessage()}
        />
      )}
      {followUpModal && (
        <FollowUpRemarks
          bookingData={carDatail}
          setOpen={setFollowUpModal}
          open={followUpModal}
        />
      )}
      {cancel && (
        <Modal
          setOpen={setCancel}
          desc={"Are you sure you want to decline request ?"}
          heading={"Deline Request"}
          open={cancel}
          loading={loading}
          onCancel={() => {
            setCancel(false);
          }}
          onClick={() => AMReAllocationDeniedAPi(reallocationValues)}
          type="Simple alert"
        />
      )}

      {accept && (
        <Modal
          setOpen={setAccept}
          desc={"Are you sure you want to accept request ?"}
          heading={"Accept Request"}
          open={accept}
          loading={loading}
          onCancel={() => {
            setAccept(false);
            setEdd("");
          }}
          onClick={() => AMReAllocationAcceptAPi(reallocationValues)}
          type="Simple alert"
        >
          <div className="mt-3 mb-6 px-16">
            <Input
              type={"input with label"}
              label="Stock Manager EDD"
              inputType="date"
              value={edd}
              onChange={(e) => {
                setEdd(e.target.value);
              }}
            />
          </div>
        </Modal>
      )}
      <Navbar navbarType={"black navbar"} />
      <Heading
        headingType={"Page Headings"}
        headingText={"Re-Allocation Request"}
        BreadCrumb={BreadCrumb}
        BreadCrumHomeLink={"/stm-dashboard"}
      />
      <div className={classes.maincontainer}>
        <Tab tabs={tabs} type="Reallocation request" setTabType={setTabType} />
        {loading ? (
          <div className={"w-full bg-white  "}>
            <img
              className="m-auto"
              src="../assets/loadingGif.gif"
              alt="loading"
            />
          </div>
        ) : (
          <>
            {tabType === "Pending Request" ? (
              <>
                {listData?.length > 0 ? (
                  listData?.map((item, index) => {
                    return (
                      <StackedList
                        type="Reallocation request stm"
                        setCancel={setCancel}
                        setAccept={setAccept}
                        data={item}
                        index={index}
                        tabType={tabType}
                        values={values}
                        followUpHandler={followUpHandler}
                      />
                    );
                  })
                ) : (
                  <DataNotFound />
                )}
              </>
            ) : (
              <>
                {historyListData?.length > 0 ? (
                  historyListData?.map((item, index) => {
                    return (
                      <div className={classes.list}>
                        <div className={classes.stackListContainer}>
                          <div role="list" className={classes.stackListWrapper}>
                            <StackedList
                              type="Reallocation request stm"
                              setCancel={setCancel}
                              setAccept={setAccept}
                              data={item}
                              index={index}
                              tabType={tabType}
                              values={values}
                              followUpHandler={followUpHandler}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <DataNotFound />
                )}
              </>
            )}
          </>
        )}

        <div className="bg-white">
          {maxPages > 1 && <Pagination maxPages={maxPages} />}
        </div>
      </div>
    </>
  );
};

export default ReallocationRequest;
